import gameData from '../../gameData.js';
import TrayBaseDraggers from './trayBaseDraggers.js';
import trayMini from "./trayMini.js";
import ABCyaLib from "@abcya/abcya_lib";

export default class LetterTray extends TrayBaseDraggers
{
    constructor(scene, parentCont, type, ind)
    {
        super(scene, parentCont, type, ind);

        this.scene = scene;
        this.pCont = parentCont;
        this.type = type;
        this.ind = ind;

        this.createLetterTray();
        this.createMiniTray();

        this.setPosition(0, 0);
        this.scene.addToParent(this, this.pCont);
    }

    createLetterTray()
    {
      const letterRef = gameData.defaultSpanish ? ABCyaLib.Environment.instance.gameConfig.spanishDefaults.letterArray : ABCyaLib.Environment.instance.gameConfig.letterTray.letterArray;
      const padding = gameData.defaultSpanish ? ABCyaLib.Environment.instance.gameConfig.spanishDefaults.letterPadding : ABCyaLib.Environment.instance.gameConfig.letterTray.letterPadding;

      for(let i=0; i<letterRef.length; i++){
        const letter = this.scene.addImage(0, 0, letterRef[i], this);
        letter.isClone = false;
        letter.type = "letter";
        letter.baseScale = .5;
        this.accessories.push(letter);

        const newScale = gameData.defaultSpanish ? ABCyaLib.Environment.instance.gameConfig.spanishDefaults.letterScale : ABCyaLib.Environment.instance.gameConfig.letterTray.letterScale;
        const startY = gameData.defaultSpanish ? ABCyaLib.Environment.instance.gameConfig.spanishDefaults.startY : ABCyaLib.Environment.instance.gameConfig.letterTray.startY;

        letter.x = letter.startX = i%2 ? 88 : 28;
        letter.y = letter.startY = i%2 ? this.accessories[i-1].y : i === 0 ? startY : this.accessories[i-1].y + (padding * newScale);

        letter.setScale(newScale);

        this.addDragFunctions(letter);
      }

      //adjust height/scale for accented letters
      const accentAdj = ["á", "é", "í", "ñ", "ó"];
      this.accessories.forEach(letter => { 
        if(accentAdj.indexOf(letter.frame.name) != -1) {
          letter.y -= 5;
          letter.startY = letter.y;
          letter.setScale(gameData.defaultSpanish ? ABCyaLib.Environment.instance.gameConfig.spanishDefaults.letterScale : ABCyaLib.Environment.instance.gameConfig.letterTray.letterScale);
        }
      });
    }

    createMiniTray()
    {
        this.miniTray = new trayMini(this.scene, this, "color");
    }

    tintLetters(color)
    {
        this.accessories.forEach(letter => {letter.tint = color;});
    }

    cleanUp()
    {
        this.toggleBtns(false);
        
        if(this.miniTray){
            this.miniTray.cleanUp();
        }
    }
}